import { PermissionAccessLevel } from '@ardoq/api-types';
import { permissionAccessLevelOperations } from '@ardoq/core';
import { FlexBox } from '@ardoq/layout';
import { Tag, TAG_DIV_SELECTOR } from '@ardoq/status-ui';
import { Text } from '@ardoq/typography';
import styled from 'styled-components';

const PermissionDecoratorWrapper = styled(FlexBox).attrs({
  justify: 'start',
  align: 'center',
})<{
  $iconColor?: string;
  $borderColor?: string;
  $backgroundColor?: string;
}>`
  ${TAG_DIV_SELECTOR} {
    color: ${({ $iconColor }) => $iconColor};
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    border-color: ${({ $borderColor }) => $borderColor};
  }
`;

export const PermissionDecorator = ({
  accessLevel,
}: {
  accessLevel: PermissionAccessLevel | null;
}) => {
  if (accessLevel === null) {
    return (
      <PermissionDecoratorWrapper>
        <Text variant="text1Italic" color="textSubtle">
          No access
        </Text>
      </PermissionDecoratorWrapper>
    );
  }
  const { color, label, iconName } =
    permissionAccessLevelOperations.getAccessLevelDisplayData(accessLevel);
  return (
    <PermissionDecoratorWrapper
      $iconColor={color?.icon}
      $borderColor={color?.border}
      $backgroundColor={color?.background}
    >
      <Tag
        leftIcon={{
          name: iconName,
          color: color?.icon,
        }}
        label={label}
      />
    </PermissionDecoratorWrapper>
  );
};
